module.exports = __webpack_public_path__ + "static/media/Kiribati - KI.8c15e80f.png";